import React from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ContentLayout } from '../../layouts/MainFrame/ContentLayout';
import { useTranslation } from 'react-i18next';

export const CollectionPageWrapper: React.FC<{ children?: React.ReactNode }> = (
    props
) => {
    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS',
    });
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <ContentLayout>
            <Grid container spacing={2}>
                {!isMobile && (
                    <Grid item xs={2}>
                        <Typography
                            variant="h2"
                            gutterBottom
                            sx={{ marginBottom: '1rem' }}
                        >
                            {t('FILTER')}
                        </Typography>
                    </Grid>
                )}
                <Grid item xs>
                    {props.children}
                </Grid>
            </Grid>
        </ContentLayout>
    );
};
